/* ============================================================
   Grusshoppen header — mega-menu, mobil-drawer, sticky-on-scroll.
   Vanilla-port af React-headeren. Idempotent + theme-editor-sikker
   (re-init på shopify:section:load).
   ============================================================ */
(function () {
  function initHeader(root) {
    if (!root || root.dataset.ghInit === '1') return;
    root.dataset.ghInit = '1';

    /* sticky on scroll */
    var onScroll = function () { root.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* desktop mega-menus */
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-gh-nav]'));
    var closeAll = function () {
      items.forEach(function (it) {
        it.classList.remove('is-open');
        var b = it.querySelector('.navlink-drop');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    };
    items.forEach(function (it) {
      var btn = it.querySelector('.navlink-drop');
      it.addEventListener('mouseenter', function () {
        closeAll(); it.classList.add('is-open');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      });
      it.addEventListener('mouseleave', function () {
        it.classList.remove('is-open');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = it.classList.contains('is-open');
        closeAll();
        if (!isOpen) { it.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeAll(); });
    root.addEventListener('keyup', function (e) { if (e.key === 'Escape') closeAll(); });

    /* mobile drawer */
    var openBtn = root.querySelector('[data-gh-mobopen]');
    var mob = root.querySelector('[data-gh-mobmenu]');
    var lockScroll = function (on) { document.documentElement.style.overflow = on ? 'hidden' : ''; };
    var closeMob = function () { if (mob) { mob.hidden = true; lockScroll(false); } };
    var openMob = function () { if (mob) { mob.hidden = false; lockScroll(true); } };
    if (openBtn) openBtn.addEventListener('click', openMob);
    if (mob) {
      mob.querySelectorAll('[data-gh-mobclose]').forEach(function (b) { b.addEventListener('click', closeMob); });
      mob.addEventListener('click', function (e) { if (e.target === mob) closeMob(); });
      mob.querySelectorAll('[data-gh-mobtoggle]').forEach(function (b) {
        b.addEventListener('click', function () {
          var sub = b.parentElement.querySelector('.mobsub');
          var chev = b.querySelector('.chev');
          if (sub) {
            sub.hidden = !sub.hidden;
            if (chev) chev.style.transform = sub.hidden ? '' : 'rotate(180deg)';
          }
        });
      });
    }
  }

  function initAll() { document.querySelectorAll('[data-gh-header]').forEach(initHeader); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-gh-header]');
    if (root) { root.dataset.ghInit = ''; initHeader(root); }
  });
})();
